//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Object.js";
import "../no/FacetSelectionRule.js";
import "../no/ugmath.js";
import "../no/Part.js";
let d=[[],[[["facets"],"CreateRuleSingleFacet",{R_:{single_facet_rule:"SingleFacetRule"}},1,0],[["faces"],"CreateRuleFaceFacets",{R_:{face_facets_rule:"FaceFacetsRule"}},1,0],[["seedFacet","isDeselectionRule"],"CreateRuleFloodFillFacets",{R_:{flood_filled_facets_rule:"FloodFillFacetsRule"}},2,0],[["brush_tool_start_point","brush_tool_direction","brush_tool_radius","allowHiddenFacetsSel","seedFacet"],"CreateRuleRoughBrushFacets",{R_:{brush_facets_rule:"RoughBrushFacetsRule"}},5,0],[["brush_tool_start_point","brush_tool_direction","brush_tool_radius","allowHiddenFacetsSel","seedFacet"],"CreateRuleFineBrushFacets",{R_:{brush_facets_rule:"FineBrushFacetsRule"}},5,0],[["seedFacet"],"CreateRuleColorRegionFacets",{R_:{color_region_rule:"ColorRegionRule"}},1,0],[["boundaryFacets","seedFacet","includeBoudaryFacets"],"CreateRuleFillBoundary",{R_:{fill_boundary_rule:"FillBoundaryRule"}},3,0],[["boundaryFacets","seedFacets","includeBoudaryFacets"],"CreateRuleFillBoundary1",{R_:{fill_boundary_rule:"FillBoundaryRule"}},3,0],[["bodies"],"CreateRuleBodyFacets",{R_:{body_facets_rule:"BodyFacetsRule"}},1,0],[["seedFacet","primitiveShapeToleranceFactor"],"CreateRulePrimitiveFacets",{R_:{primitive_facets_rule:"PrimitiveFacetsRule"}},2,0],[["seedFacet","tangencyTolerance"],"CreateRuleTangentFacets",{R_:{tangent_facets_rule:"TangentFacetsRule"}},2,0],[["seedFacet"],"CreateRuleWithinCurves",{R_:{within_curves_rule:"WithinCurvesRule"}},1,0]],[]];
SPLM.FacetSelectionRuleFactory = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.FacetSelectionRuleFactory";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;